import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = sessionStorage.getItem('adminToken');
      const isAuth = sessionStorage.getItem('isAuthenticated') === 'true';
      
      if (!token || !isAuth) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      // Verificar se o JWT expirou localmente (opcional)
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const now = Math.floor(Date.now() / 1000);
        
        if (payload.exp && payload.exp < now) {
          // Token expirado localmente
          sessionStorage.removeItem('adminToken');
          sessionStorage.removeItem('adminUser');
          sessionStorage.removeItem('isAuthenticated');
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }
      } catch (error) {
        // Token malformado, limpar
        sessionStorage.removeItem('adminToken');
        sessionStorage.removeItem('adminUser');
        sessionStorage.removeItem('isAuthenticated');
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      try {
        // Verificar se o token ainda é válido no servidor
        const response = await authService.getCurrentUser();
        if (response.success) {
          setIsAuthenticated(true);
        } else {
          // Token inválido, limpar sessionStorage
          sessionStorage.removeItem('adminToken');
          sessionStorage.removeItem('adminUser');
          sessionStorage.removeItem('isAuthenticated');
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Erro ao verificar autenticação:', error);
        // Em caso de erro, limpar sessionStorage
        sessionStorage.removeItem('adminToken');
        sessionStorage.removeItem('adminUser');
        sessionStorage.removeItem('isAuthenticated');
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-brand-sand flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-brand-slate border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-brand-slate">Verificando autenticação...</p>
        </div>
      </div>
    );
  }
  
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
